export default __webpack_public_path__ + "static/media/phoneFrame.f84522f5.svg";